import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiCheckCircle } = FiIcons;

const testimonials = [
  {
    name: "Sarah Jenkins",
    location: "Austin, TX",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    text: "RenewRX completely changed my approach to weight loss. The virtual consultation was seamless, and getting the medication delivered right to my door took all the stress away. I'm down 25 lbs and feeling amazing!",
    rating: 5,
    verified: true
  },
  {
    name: "Michael Chen",
    location: "Seattle, WA",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    text: "I was hesitant about telehealth at first, but the medical team was incredibly thorough and answered all my questions. The pricing is transparent, and the results have been life-changing. Highly recommend.",
    rating: 5,
    verified: true
  },
  {
    name: "Emily Rodriguez",
    location: "Miami, FL",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    text: "Finally, a service that doesn't make you jump through hoops. The intake process took 5 minutes, my doctor was wonderful, and the shipment arrived in two days. I've successfully maintained my goal weight for 4 months.",
    rating: 5,
    verified: true
  }
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-[#fafaf9] relative overflow-hidden border-t border-slate-200/50">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-teal-50/50 rounded-l-full blur-3xl -z-10 transform translate-x-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2 className="text-sm font-bold text-teal-700 tracking-widest uppercase mb-4">Patient Success Stories</h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight mb-6">Real people. Real results.</h3>
          <p className="text-xl text-slate-600 leading-relaxed font-light">
            Don't just take our word for it. Hear from thousands of patients who have transformed their lives with our premium medical weight loss programs.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.15, duration: 0.6 }}
              className="bg-white rounded-3xl p-8 premium-card-hover border border-slate-200/60 flex flex-col h-full"
            >
              <div className="flex justify-between items-center mb-6">
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, index) => (
                    <SafeIcon key={index} icon={FiStar} className="w-5 h-5 text-amber-400 fill-amber-400" />
                  ))}
                </div>
                {testimonial.verified && (
                  <div className="flex items-center gap-1 text-xs font-bold text-teal-700 bg-teal-50 px-2 py-1 rounded-md">
                    <SafeIcon icon={FiCheckCircle} className="w-3 h-3" /> Verified Patient
                  </div>
                )}
              </div>
              
              <blockquote className="text-slate-700 text-lg leading-relaxed mb-8 flex-grow font-light">
                "{testimonial.text}"
              </blockquote>
              
              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-slate-100">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-12 h-12 rounded-full object-cover border-2 border-slate-100 shadow-sm" 
                />
                <div>
                  <div className="font-bold text-slate-900">{testimonial.name}</div>
                  <div className="text-sm text-slate-500">{testimonial.location}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}